export default __webpack_public_path__ + "static/media/step-1-complete.e7485e43.svg";